import { Link } from "react-router-dom";
import { featuredVideos } from "@/mocks/videos";

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">精选高分影视，大家都在看</p>
          </div>
          <Link
            to="/category/tv-series"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featuredVideos.slice(0, 10).map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  title={`${video.title} - ${video.category}高清在线观看`}
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-xs text-white/80">{video.episodes > 1 ? `${video.episodes}集` : "电影"}</span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{video.source}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}